module.exports = __webpack_public_path__ + "img/3_Disease_models_and_mechanisms_cover.5003da68.jpg";